import React from "react";
import { groupByKey } from "../../helpers";

const ProductAppList = ({ productApps }) => {
  if (
    productApps !== "" &&
    productApps.status === "OK" &&
    productApps.data.product_apps.length
  ) {
    const groupedData = groupByKey(productApps.data.product_apps, "group_id");

    return Object.keys(groupedData).map((groupItem, groupIndex) => {
      return (
        <li className="list__item" key={groupIndex}>
          <div className="list__link pr clear-fix">
            <h3 className="list__app-title fs14">
              {groupedData[groupItem][0].group_name}
            </h3>
            <ul className="list__app-list">
              {groupedData[groupItem].map((item, index) => (
                <li className="list__app-item" key={index}>
                  <img src={item.icon} alt={item.group_name} width="30" />
                </li>
              ))}
            </ul>
          </div>
        </li>
      );
    });
  }

  return "";
};

export default ProductAppList;
